var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text"},[_vm._v(" Quer imprimir nossa folha de redação? "),_c('a',{staticClass:"sheet",on:{"click":_vm.downloadSheet}},[_vm._v(" Clique aqui ")]),_vm._v(" e baixe! ")])}
var staticRenderFns = []

export { render, staticRenderFns }